var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarcodeWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 64,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7068,
    transform: "translate(-218 -3370)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1196,
    transform: "translate(-223 -274)",
    fill: "#312F30"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: -24,
    width: 577,
    height: 123,
    rx: 15,
    fill: "white",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6665 48.9582H23.3332C16.6415 48.9582 12.7915 45.1082 12.7915 38.4165V25.5832C12.7915 18.8915 16.6415 15.0415 23.3332 15.0415H41.6665C48.3582 15.0415 52.2082 18.8915 52.2082 25.5832V38.4165C52.2082 45.1082 48.3582 48.9582 41.6665 48.9582ZM23.3332 17.7915C18.0898 17.7915 15.5415 20.3398 15.5415 25.5832V38.4165C15.5415 43.6598 18.0898 46.2082 23.3332 46.2082H41.6665C46.9098 46.2082 49.4582 43.6598 49.4582 38.4165V25.5832C49.4582 20.3398 46.9098 17.7915 41.6665 17.7915H23.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 40.7082C20.7483 40.7082 20.125 40.0848 20.125 39.3332V24.6665C20.125 23.9148 20.7483 23.2915 21.5 23.2915C22.2517 23.2915 22.875 23.9148 22.875 24.6665V39.3332C22.875 40.0848 22.2517 40.7082 21.5 40.7082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 33.3748C26.2483 33.3748 25.625 32.7515 25.625 31.9998V24.6665C25.625 23.9148 26.2483 23.2915 27 23.2915C27.7517 23.2915 28.375 23.9148 28.375 24.6665V31.9998C28.375 32.7515 27.7517 33.3748 27 33.3748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 40.7083C26.2483 40.7083 25.625 40.085 25.625 39.3333V37.5C25.625 36.7483 26.2483 36.125 27 36.125C27.7517 36.125 28.375 36.7483 28.375 37.5V39.3333C28.375 40.085 27.7517 40.7083 27 40.7083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 27.8748C37.2483 27.8748 36.625 27.2515 36.625 26.4998V24.6665C36.625 23.9148 37.2483 23.2915 38 23.2915C38.7517 23.2915 39.375 23.9148 39.375 24.6665V26.4998C39.375 27.2515 38.7517 27.8748 38 27.8748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 40.7082C31.7483 40.7082 31.125 40.0848 31.125 39.3332V24.6665C31.125 23.9148 31.7483 23.2915 32.5 23.2915C33.2517 23.2915 33.875 23.9148 33.875 24.6665V39.3332C33.875 40.0848 33.2517 40.7082 32.5 40.7082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 40.7083C37.2483 40.7083 36.625 40.085 36.625 39.3333V32C36.625 31.2483 37.2483 30.625 38 30.625C38.7517 30.625 39.375 31.2483 39.375 32V39.3333C39.375 40.085 38.7517 40.7083 38 40.7083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 40.7082C42.7483 40.7082 42.125 40.0848 42.125 39.3332V24.6665C42.125 23.9148 42.7483 23.2915 43.5 23.2915C44.2517 23.2915 44.875 23.9148 44.875 24.6665V39.3332C44.875 40.0848 44.2517 40.7082 43.5 40.7082Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_0_1",
    x: -47.5,
    y: -28,
    width: 625,
    height: 175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7068,
    fill: "white",
    transform: "translate(-218 -3370)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeWhite);
export default __webpack_public_path__ + "static/media/barcode-white.207f5dc2685b4d1ef435e5a76c3317a0.svg";
export { ForwardRef as ReactComponent };